<template>
  <v-container fluid class="font">
    <v-card flat>
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="refundForm" v-model="isValid">
          <v-row>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                label="Requested Amount"
                placeholder="Enter The Requested Amount"
                persistent-placeholder
                dense
                type="number"
                clearable
                :readonly="isReadonly"
                min="1"
                v-model="formData.requestedRefundAmt"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                label="Profile Number"
                dense
                v-model="formData.profileID"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                label="Registration Number"
                dense
                v-model="formData.studentNo"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <div class="attachment--documents">
                <v-chip-group
                  active-class="orange darken-2"
                  column
                  multiple
                  class="mx-2"
                >
                  <v-chip
                    v-for="(item, i) in attachments"
                    :key="i"
                    color="primary"
                    outlined
                    label
                    :disabled="isReadonly"
                  >
                    <v-btn
                      left
                      color="primary"
                      class="text-capitalize"
                      text
                      @click="editAttachment(item, i)"
                      :disabled="isReadonly"
                    >
                      {{ item.fileName }}
                    </v-btn>
                    <v-divider vertical></v-divider>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          class="py-2 ml-4"
                          icon
                          :disabled="isReadonly"
                          right
                          v-on="on"
                          v-bind="attrs"
                          color="deep-orange"
                          @click="removeAttachment(i, item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Remove Attachment</span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
                <div class="d-flex justify-center flex-column">
                  <div
                    :class="
                      attachments.length !== 0
                        ? 'align-self-center mt-3'
                        : 'align-self-center'
                    "
                  >
                    <RefundAttachments
                      :isEdit="isEdit"
                      :BtnCaption="BtnCaption"
                      @addAttachment="addAttachment"
                      :isReadonly="isReadonly"
                      :data="displayAttachment"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          elevation="0"
          v-if="!isEdit && !isReadonly"
          color="primary"
          class="text-capitalize mb-5"
          @click="saveRefund"
        >
          <v-icon left> mdi-send </v-icon>
          <span>Save Student Refund Request</span>
        </v-btn>
        <v-btn
          v-if="isEdit && !isReadonly"
          class="text-capitalize mb-5"
          color="primary"
          @click="updateRefund"
        >
          <v-icon left> mdi-send </v-icon>
          <span>Save Updated Changes</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { helper } from "../../dashboard/utils";
import { AuthService } from "@brainspore/celadon-base/modules/auth";
import RefundAttachments from "./RefundAttachments";
export default {
  name: "RefundCard",
  components: { RefundAttachments },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.params.code) {
        v.$store.dispatch("Refund/getRefund", to.params.code);
        window.document.title = "KISEB::View Refund";
      } else {
        window.document.title = "KISEB::Apply Refund";
      }
      v.formData.profileID = v.profile["profileID"];
      v.formData.studentNo = v.student["no"];
    });
  },
  data: () => ({
    attachments: [],
    displayAttachment: {},
    isValid: false,
    submitting: false,
    formData: {
      profileID: "",
      studentNo: "",
      requestedRefundAmt: 1,
      attachmentAPI: [],
    },
  }),
  created() {},
  mounted() {},
  computed: {
    BtnCaption() {
      return this.attachments.length === 0
        ? "Attach Refund Documents"
        : "Add Refund Document";
    },
    refund() {
      return this.$store.getters["Refund/refundGetter"]("refund");
    },
    isEdit() {
      return this.$route.params.code && this.formData.status === "Open";
    },
    isReadonly() {
      return this.$route.params.code && this.formData.status !== "Open";
    },
    // this computed value returns the programme name and the stage
    student() {
      return AuthService.user.student;
    },
    profile() {
      return AuthService.user.profile;
    },
    studentBalance() {
      return this.$store.getters["Refund/refundGetter"]("studentBalance");
    },
  },
  methods: {
    setAttachmentDialog(val) {
      this.$store.dispatch("Refund/setAttachmentDialog", val);
    },
    editAttachment(val, index) {
      val.index = index;
      this.displayAttachment = val;
      this.setAttachmentDialog(true);
    },
    removeAttachment(index, item) {
      if (item.lineNo) {
        // delete Refund line
        this.$confirm.show({
          title: `Delete Refund Attachment ${item.lineNo}?`,
          text: "Are you sure you want to delete this Refund Attachment, this action is irreversible",
          onConfirm: () => {
            this.$store.dispatch("Refund/deleteAttachment", { ...item });
          },
        });
      } else {
        this.attachments.splice(index, 1);
      }
    },
    async addAttachment(file) {
      this.displayAttachment = {};
      if (file.index !== undefined) {
        Object.assign(this.attachments[file.index], file);
        delete this.attachments[file.index].index;
      } else {
        delete file.index;
        this.attachments.push(file);
      }
    },
    // save the Refund Request
    saveRefund: function () {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.refundForm.validate();
        this.submitting = false;
      } else if (this.attachments.length === 0) {
        Event.$emit("ApiError", "Attach Refund Proof to proceed!");
      } else {
        const data = { ...this.formData };
        data.requestedRefundAmt = parseInt(data.requestedRefundAmt);
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        this.$confirm.show({
          title: "Student Refund Request",
          text: `Save and send Student Refund Request for approval?`,
          onConfirm: () => {
            if (this.studentBalance === 0) {
              this.$alert({
                title: "Insufficient Student Balance",
                text: `Sorry, you student balance is ${this.studentBalance}`,
              });
            } else {
              this.$store.dispatch("Refund/saveRefund", {
                ...data,
              });
            }
          },
        });
      }
    },
    updateRefund: function () {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.refundForm.validate();
        this.submitting = false;
      } else if (this.attachments.length === 0) {
        Event.$emit("ApiError", "Attach Refund Proof to proceed!");
      } else {
        const data = { ...this.formData };
        data.requestedRefundAmt = parseInt(data.requestedRefundAmt);
        delete data.documentDate;
        delete data.amountLCY;
        data.attachmentAPI = [];
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        this.$confirm.show({
          title: "Student Refund Request",
          text: `Update/Save and send Student Refund Request for approval?`,
          onConfirm: () => {
            this.$store.dispatch("Refund/patchRefund", {
              ...data,
            });
          },
        });
      }
    },
  },
  watch: {
    refund: {
      handler: function (data) {
        const attachments = data.attachmentAPI;
        delete data.attachmentAPI;
        this.formData = { ...data };
        const base64Attachments = [];
        attachments.map(async (el) => {
          const blob = await helper.getFileBlob(
            process.env.VUE_APP_TEMP_URL + el.base64Attachment,
            el.documentNo,
          );
          const base64 = await helper.toBase64(blob);
          base64Attachments.push({
            base64Attachment: base64.split(",")[1],
            fileName: `${blob.name}${el.lineNo}.${blob.type.split("/")[1]}`,
            comment: el.comment,
            blob,
            lineNo: el.lineNo,
            documentNo: el.documentNo,
            documentType: el.documentType,
          });
        });
        this.attachments = base64Attachments;
      },
    },
  },
};
</script>

<style scoped>
@import url("../styles/styles.css");
</style>
